var notices = require('../notices')
var raygun = require('../raygun');

function init() {
    var joinBtns = document.querySelectorAll('.sdv .button');
    if (joinBtns) {
        Array.from(joinBtns).forEach(function(joinBtn) {
            joinBtn.addEventListener('click', function (e) {
                showHideSpinner(true)
                callEndpoint(e.currentTarget.dataset.href)
            })
        })
    }

    var sdgCoRegClaimBtn = document.querySelector('[data-sdgCoReg-claim]');
    if (sdgCoRegClaimBtn) {
        sdgCoRegClaimBtn.addEventListener('click', function (e) {
            var confirmed = document.querySelector('[data-confirm]');
            var confirmError = document.querySelector('[data-confirm-error]');
            var sdgADs = document.querySelector('[data-sdgCoReg]');
            if(confirmed){
              if(confirmed.checked){
                if(confirmError){
                  showHideError(true)
                }
                showHideSpinner(true)
                //callEndpoint(e.currentTarget.dataset.href)
                if(sdgADs != 'undefined'){
                  sdgADs.classList.add('hide')
                  /*var menuLink1 = document.querySelector('[data-memberMenuLink1]');
                  var menuLink2 = document.querySelector('[data-memberMenuLink2]');
                  menuLink1.classList.remove('hide')
                  menuLink2.classList.add('hide')*/
                }
                } else {
                  if(confirmError){
                    showHideError(false)
                  }
                }
              }
        })
    }

    var sdgLaunchFreeTrialBtns = document.querySelector('[data-launchFreeTrial]');
    if (sdgLaunchFreeTrialBtns) {
        sdgLaunchFreeTrialBtns.addEventListener('click', function (e) {
            var sdgADs = document.querySelector('[data-sdgCoReg]');
            var headerSiteLogo = document.querySelector('[data-headerSiteLogo]');
            var viewSinglesNow = document.querySelector('[data-viewSinglesNow]');
            sdgADs.classList.add('hide');
            headerSiteLogo.removeAttribute('data-new-window');
            viewSinglesNow.removeAttribute('data-new-window');
        })
    }
}

function checkTick(){
    var confirmed = document.querySelector('[data-confirm]');
    if(confirmed){
          showHideError(confirmed.checked)
          enableDisableHREF(confirmed.checked)
    }
}

function enableDisableHREF(confirmed){
  var sdgCoRegClaimBtn = document.querySelector('[data-sdgCoReg-claim]');
  if(sdgCoRegClaimBtn){
    //pointer-events-none is added to <a> on page load, so we need to remove it for link to work
      sdgCoRegClaimBtn.classList[confirmed? 'remove':'add']('pointer-events-none')
  }
}

function showHideError(hide){
  var confirmError = document.querySelector('[data-confirm-error]');
  if(confirmError){
    confirmError.hidden = hide
  }
}

function showHideSpinner(show){
    var spinner = document.querySelector('[data-spinner]');
    if (spinner) {
        if (show) {
            spinner.hidden = false
        } else {
            spinner.hidden = true
        }
    }
}

function callEndpoint(url){
    fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    })
    .then(function (res) {
        return res.json()
    })
    .then(function (res) {
        if (res.status == 200) {
          window.location = res.redirectLink
        } else {
            showHideSpinner(false)
            //show error message
            notices.warn(res.message)
            //check we have a redirect link
            if (res.redirectLink) {
                setTimeout(function () {
                    window.location = res.redirectLink
                }, 5000)
            }
        }
    })
    .catch((error) => {
      showHideSpinner(false)
      raygun.sendError(error, 'sdvPromoCallEndPoint');
    });
}

document.addEventListener('change', checkTick)
document.addEventListener('click', checkTick)
document.addEventListener('DOMContentLoaded',init)